import { FormControl, FormGroup, ValidationErrors } from '@angular/forms';
import { Countries } from '../constants/countries.constants';
import { Regex } from '../constants/regex.constants';
import { ISelectOption } from '../models/common';
import { Guid } from '@lsq-frontend/remote-services/enterprise/common';

export class Utilities {
    public static executeAfterRender(func: Function): void {
        setTimeout(func);
    }

    public static replaceHtmlInString(str: string, replacementString?: string): string {
        let formattedString: string;
        const regex = new RegExp(Regex.HtmlTag, 'gi');
        if (!regex.test(str)) {
            return str;
        }
        formattedString = str.replace(regex, replacementString ? replacementString : ' ');
        if (!replacementString) {
            formattedString.replace(new RegExp(Regex.MultiSpace), 'g');
        }
        return formattedString;
    }

    public static isUsa(country: string): boolean {
        if (country) {
            if (
                country.toLowerCase() === Countries.Usa.toLowerCase() ||
                country.toLowerCase() === Countries.UnitedStates.toLowerCase() ||
                country.toLowerCase() === Countries.UnitedStatesOfAmerica.toLowerCase()
            ) {
                return true;
            }
        }
        return false;
    }

    public static withEmptySelectOption(options: ISelectOption[]): ISelectOption[] {
        return [{ label: '', value: null }, ...options];
    }

    // Generates form controls based on the keys you give it.
    public static generateFormControls(keys: string[], properties: any): { [key: string]: any } {
        const formControls = {};
        keys.forEach((key) => {
            if (properties) {
                properties.forEach((prop: any) => {
                    if (prop.name === key) {
                        formControls[key] = new FormControl(
                            prop.defaultValue,
                            prop.validators || []
                        );
                    }
                });
            }
        });
        return formControls;
    }

    // For debugging; Console logs form errors.
    public static logFormValidationErrors(formGroup: FormGroup): void {
        Object.keys(formGroup.controls).forEach((key) => {
            const controlErrors: ValidationErrors = formGroup.get(key).errors;
            if (controlErrors != null) {
                Object.keys(controlErrors).forEach((keyError) => {
                    console.log(
                        'Key control: ' + key + ', keyError: ' + keyError + ', err value: ',
                        controlErrors[keyError]
                    );
                });
            }
        });
    }

    public static convertEnumToDisplayArray(enumObject: object): string[] {
        const values = Object.values(enumObject).filter(
            (enumValue) => typeof enumValue === 'string'
        );
        return values;
    }

    public static kebabCaseToSentenceCase(value: string): string {
        const removedDashesResult = value.replace(new RegExp('-', 'g'), ' ');
        const addedSpacesResult = removedDashesResult.replace(
            new RegExp(Regex.SentenceCase, 'g'),
            '$1 $2'
        );
        const result = addedSpacesResult.charAt(0).toUpperCase() + addedSpacesResult.slice(1);
        return result.trim();
    }

    public static convertGuidToKey(guid: Guid): number {
        const allDashesAndNonDigitsRegex = /[-\D]/g;
        return +guid.replace(allDashesAndNonDigitsRegex, '');
    }

    public static getISOStringWithoutTimezone(date: Date): string {
        if (!date) {
            return null;
        }
        return `${date.toISOString().split('T')[0]}T00:00:00.000`;
    }
}
